import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from './services/ThemeContext'
import { ComparisonProvider } from './services/ComparisonContext.tsx'
import { ToastProvider } from './services/ToastContext.tsx'
import { HelmetProvider } from 'react-helmet-async';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
      <HelmetProvider>
          <ThemeProvider>
            <ToastProvider>
              {/* CountryProvider & CurrencyProvider moved to App.tsx (need Router) */}
              <ComparisonProvider>
                <App />
              </ComparisonProvider>
            </ToastProvider>
          </ThemeProvider>
      </HelmetProvider>
  </React.StrictMode>,
)


